import { getMyExplorerOnboarding } from "../api/explorerOnboardingApi";
import { getExplorerPendingOnboarding } from "./explorerSession";

/** Shared with event booking flow (ConfirmBooking clears this on success). */
export const EVENT_DATA_KEY = "event-data";
const OBJECTIVES_FOR_ATTENDING_KEY = "objectivesForAttending";
const STAGE_OF_BUSINESS_KEY = "stageOfBusiness";
const SECTORS_OF_INTEREST_KEY = "sectorsOfInterest";
const PHOTO_SHARING_CONSENT_KEY = "photoSharingConsent";

export type EventBookingFormShape = {
  stageOfBusiness: string;
  objectives: string;
  sectorsOfInterest: string[];
  consentToShare: boolean;
};

function buildExplorerBookingFromDiscoveryAnswers(
  answers: Record<string, string> | undefined | null,
): EventBookingFormShape {
  const a = answers ?? {};
  const sectorsRaw = a[SECTORS_OF_INTEREST_KEY] ?? "";
  return {
    stageOfBusiness: a[STAGE_OF_BUSINESS_KEY] ?? "",
    objectives: a[OBJECTIVES_FOR_ATTENDING_KEY] ?? "",
    sectorsOfInterest: sectorsRaw
      ? sectorsRaw
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      : [],
    consentToShare: a[PHOTO_SHARING_CONSENT_KEY] === "true",
  };
}

/** event-questions localStorage, session pending, or explorer profile (after checkout cleared pending). */
export async function resolveEventBookingFormData(): Promise<EventBookingFormShape> {
  const stored = localStorage.getItem(EVENT_DATA_KEY);
  if (stored) {
    try {
      const parsed = JSON.parse(stored) as {
        stageOfBusiness?: string;
        objectives?: string;
        sectorsOfInterest?: string[];
        consentToShare?: boolean;
      };
      return {
        stageOfBusiness: parsed.stageOfBusiness ?? "",
        objectives: parsed.objectives ?? "",
        sectorsOfInterest: Array.isArray(parsed.sectorsOfInterest)
          ? parsed.sectorsOfInterest
          : [],
        consentToShare: Boolean(parsed.consentToShare),
      };
    } catch {
      /* use fallbacks below */
    }
  }
  const pending = getExplorerPendingOnboarding();
  const answers = pending?.discoveryAnswers;
  if (answers && Object.keys(answers).length > 0) {
    return buildExplorerBookingFromDiscoveryAnswers(answers);
  }
  try {
    const me = await getMyExplorerOnboarding();
    return buildExplorerBookingFromDiscoveryAnswers(
      me.payload?.discoveryAnswers ?? undefined,
    );
  } catch {
    return buildExplorerBookingFromDiscoveryAnswers(undefined);
  }
}
